<template>
  <Modal ref="modalElem" title="Confirm remove" ok-text="Remove" ok-style="danger" busy-text="Removing..." @ok="onOk">
    <p>{{ confirmMessageRef }}</p>
    <UserItem v-if="pmRef?.member" :user-id="pmRef.member.userId" />
    <ProfileCard v-else :person-id="pmRef?.profileGroup?.startItemId" />
    <div v-if="pmRef?.lastUserInvite?.result == InvitationResult.Pending" class="alert alert-warning">
      This profile has a pending invitation. Removing the profile will cancel the invitation.
    </div>
  </Modal>
</template>

<style lang="scss" scoped>
p, .user-item, .profile-card {
  margin-bottom: 1rem;
}

.user-item, .profile-card {
  margin-left: 1rem;
}

.alert {
  margin: 0;
  font-size: 0.875rem;
}
</style>

<script lang="ts" setup>
import { computed, ref } from 'vue'
import { PotentialMember } from './FamilyGroupMemberManager'
import { InvitationResult } from '@/gp/GroupAdminModel'
import Modal from '@/util/Modal.vue'
import UserItem from '@/manage/users/UserItem.vue'
import ProfileCard from '@/manage/ProfileCard.vue'

defineExpose({
  open,
  close,
})

const emit = defineEmits([
  'ok',
])

const pmRef = ref<PotentialMember>()

const confirmMessageRef = computed(() => pmRef.value?.member 
  ? "Remove this user from the group?" 
  : "Remove this profile from the group?")

const modalElem = ref<InstanceType<typeof Modal>>()

function open(pm: PotentialMember) {
  pmRef.value = pm

  modalElem.value?.open()
}

function close() {
  modalElem.value?.close()
}

function onOk() {
  emit('ok', pmRef.value)
}
</script>
